import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, TextField, DialogActions, Button, Switch, Alert, CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { ErrorsFlattenner } from '../../common/errors-flattenner/errors-flattenner';
import { timestampedMessage } from '../../common/multi-package-scanner/multi-package-scanner';
import CustomDialog from '../../common/custom-dialog/custom-dialog';

interface SetFailureReasonProps {
    onSubmit: (reason: string) => void;
    onClose: () => void;
    failure_reasons: string[];
}



function SetFailureReason({ onSubmit, onClose, failure_reasons, }: SetFailureReasonProps) {
    const [reason, setReason] = useState<string>("")
    const [useCustomMessage, setUseCustomMessage] = useState(false)

    useEffect(() => {
        setReason("")
    }, [useCustomMessage])

    const handleSubmit = () => {
        onSubmit(reason)
        onClose()
    }

    return (
        <CustomDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
            < DialogTitle > Reason of Failure</DialogTitle >
            <DialogContent>
                {
                    !useCustomMessage && <FormControl fullWidth margin="normal">
                        <InputLabel>Choose Failure Reason</InputLabel>
                        <Select
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            label="Choose message template"
                        >
                            {
                                failure_reasons.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                }


                <br />
                <Switch checked={useCustomMessage} onChange={() => { setUseCustomMessage(!useCustomMessage) }} /> Custom Failure Reason
                <br />
                {useCustomMessage &&
                    <TextField
                        autoComplete="off"
                        fullWidth
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        margin="normal"
                        label="Start typing .."
                        multiline
                        rows={4}
                        variant="outlined"
                    />
                }
            </DialogContent >
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSubmit}> Save </Button>
            </DialogActions>


        </CustomDialog >
    );
}

export default SetFailureReason;